import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";
import Cookies from "js-cookie";

import { useCft } from "../../../utils/CftProvider";
import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
  CftTank,
  CftOnboarding,
} from "../../../components";
import routes from "../../../utils/cftRoutes";
import DetailsBothCalcForm, {
  DetailsBothCalcFormContext,
} from "../../../forms/farmlands/bothCalc/DetailsBothCalcForm/DetailsBothCalc.form";

export const ONBOARDING_COOKIE = "sadda3fwsdfas";

function DetailsBothCalcPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveBothCalc, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={0}
          cropName={meta.title.bothCalc}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="bothCalc" />
              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveBothCalc({
                    details: {
                      ...values,
                      name: values.name.slice(0, 30),
                    },
                  });
                  history.push(routes.FARMLANDS.BOTH_CALC.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:detailsFarmlands.title", "Szczegóły uprawy")}
          onNext={submitForm}
          onBack={!Cookies.get(ONBOARDING_COOKIE) ? () => "" : ""}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:detailsFarmlands.title", "Szczegóły uprawy")}</h3>
            <p>
              {t(
                "cft:detailsBothCalc.subtitle",
                "Wprowadź informacje dotyczące kalkulowanej uprawy i pola."
              )}
            </p>
          </>
        }
      >
        <DetailsBothCalcForm />
        <CftReportProgress type="bothCalc" />
      </CftSection>
      <CftOnboarding />
    </CftLayout>
  );
}

export default () => {
  return (
    <DetailsBothCalcFormContext>
      <DetailsBothCalcPage />
    </DetailsBothCalcFormContext>
  );
};
